<template>
  <div class="box-information-content">
    <a-card :bordered="false" size="small">
      <div slot="title" class="title-box">
        <label class="plate-title"><strong>Logs</strong></label>
      </div>
      <a-tabs type="card" default-active-key="1">
        <a-tab-pane key="1" tab="Operation(4)">
          <a-table 

            size="small"
            :columns="columns"
            :data-source="logs"
            :pagination="true"
          >
          </a-table>
        </a-tab-pane>
        <!--  -->
        <a-tab-pane key="2" tab="Confirmation(2)">
          <a-table 

            size="small"
            :columns="mailColumns"
            :data-source="mailDatas"
          >
          <template slot="pdfName" slot-scope="text,record">
            <span><a @click="previewPdf(record)">Confirmation_343087.pdf</a></span>
          </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
const logsName = [
  {
    title: 'Date/Time',
    dataIndex: 'createDateStr',
    width: '160px',
    key: 'createDateStr'
  },
  {
    title: 'Type',
    dataIndex: 'logType',
    key: 'logType',
    width: '150px',
    scopedSlots: { customRender: 'logType' }
  },
  {
    title: 'Description',
    dataIndex: 'logDescription',
    key: 'logDescription',
  },
  {
    title: 'by',
    dataIndex: 'createUid',
    key: 'createUid',
    scopedSlots: { customRender: 'createUid' }
  },
]
// 假数据
const logs = [
  {
    key: '1',
    createDateStr: '07/13/2021 2:01PM',
    logType: 'Concession',
    logDescription: 'Discounthonor old land cost $5100.00 pp/ original made 5/7/20 has been Approved OP: honor old price',
    createUid: 'Kara.Yu'
  },
  {
    key: '2',
    createDateStr: '07/13/2021 12:28PM',
    logType: 'Concession',
    logDescription: 'This discount(honor old land cost $5100.00 pp/ original made 5/7/20) has been submit',
    createUid: 'Tracy.Yen'
  },
  {
    key: '3',
    createDateStr: '07/13/2021 11:38AM',
    logType: 'Payment',
    logDescription: 'Deposit：DEPOSIT CHARGE MERCHANT ...FROM 338488 has been Approved OP: 1. XD¤0797402172/965.00/ 1000.00/ 0.00/ONE/CCVI41472024 35236052 1.1MA KWOK KIU/1/D 2. XD¤0797402173/965.00/ 1000.00/ 0.00/ONE/CCVI41472024 35236052 2.1MA ANGELA YUET MING/1/D',
    createUid: 'Mandy.Lai'
  },
  {
    key: '4',
    createDateStr: '07/13/2021 11:38AM',
    logType: 'Status',
    logDescription: 'Status Changed: from New Booking to Deposited',
    createUid: 'Mandy.Lai'
  },
]
// 假数据
const mailDatas = [
  {
    key: '1',
    createDateStr: '07/13/2021 2:01PM',
    logType: 'New booking',
    // pdfName: 'Confirmation_343087.pdf',
    createUid: 'Kara.Yu'
  },
  {
    key: '2',
    createDateStr: '07/13/2021 12:28PM',
    logType: 'New booking',
    // pdfName: 'Confirmation_343087.pdf',
    createUid: 'System'
  },

]
const mailColumns = [
  {
    title: 'Date/Time',
    dataIndex: 'createDateStr',
    width: '160px',
    key: 'createDateStr'
  },
  {
    title: 'Type',
    dataIndex: 'emailType',
    key: 'emailType',
    width: '150px',
    scopedSlots: { customRender: 'emailType' }
  },
  {
    title: 'PDF',
    dataIndex: 'pdfName',
    key: 'pdfName',
    scopedSlots: { customRender: 'pdfName' }
  },
  {
    title: 'by',
    dataIndex: 'createUid',
    key: 'createUid',
    scopedSlots: { customRender: 'createUid' }
  }
]

export default {
  name: 'BookLogsMain',
  components: {
  },
  props: {
  },
  data () {
    return {
      loading: true,
      columns: logsName,
      mailColumns: mailColumns,
      mailDatas,
      logs,
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-table-thead {
  background: #f2f2f2;
}
/deep/ .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0; 
}
</style>